/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  AreaDto,
  GetAllAreasParams,
  IReadOnlyListOfAreaDto
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Returns all area enumeration values, with an optional filter.
 */
export const getAllAreas = (
    params?: GetAllAreasParams,
 options?: SecondParameter<typeof customInstance<IReadOnlyListOfAreaDto>>,) => {
      return customInstance<IReadOnlyListOfAreaDto>(
      {url: `/deployment/areas`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Returns the Area identified by the route id.
 */
export const getAreaById = (
    id: number,
 options?: SecondParameter<typeof customInstance<AreaDto>>,) => {
      return customInstance<AreaDto>(
      {url: `/deployment/areas/${id}`, method: 'GET'
    },
      options);
    }
  export type GetAllAreasResult = NonNullable<Awaited<ReturnType<typeof getAllAreas>>>
export type GetAreaByIdResult = NonNullable<Awaited<ReturnType<typeof getAreaById>>>
